<script lang="ts">
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import CommentListEditor from "../../components/Business/CommentListEditor.svelte";
  import OwnershipListEditor from "../../components/Business/OwnershipListEditor.svelte";
  import PortalUserDropdown from "../../components/Business/PortalUserDropdown.svelte";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  // import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { ICompany } from "../../entities";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";

  import {
    record,
    save,
    initDetail    
  } from "./activity.store";
import Switch from "../../components/Form/Fields/Switch.svelte";
import MagazineSideEditor from "../../components/Business/MagazineSideEditor.svelte";
import Secur8SideEditor from "../../components/Business/Secur8SideEditor.svelte";
import { showToast } from "../../utils/misc/toast-utils";
import type { IActivityDTO } from "../../services/DTO";
import DateInput from "../../components/Form/Fields/DateInput.svelte";
import CompanyDropdown from "../../components/Business/CompanyDropdown.svelte";
import LeadDropdown from "../../components/Business/LeadDropdown.svelte";
import ContactDropdown from "../../components/Business/ContactDropdown.svelte";

const dispatch = createEventDispatcher();

  export let oid: number;  
  export let type: string;
  export let entityId : number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null 
      && $record.entityId != null
      && $record.activity.subject != "";
 
  let cancreate : boolean = PermissionService.isAllowedTo($user, 'activities.cancreate'); 
  let canedit : boolean = PermissionService.isAllowedTo($user, 'activities.canedit'); 

  let tipoentita : string = null; 

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IActivityDTO> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      dispatch("save", {activity: u});
    } else {
      dispatch("save", {activity: u});
      onCancel();
    }
  }

  function onCancel() {
     dispatch("close", {   }); 
  }


  function onStatoChange(value)
  {
    if (value.label == "Completato" && $record.activity.doneDate == null)
      $record.activity.doneDate = new Date();
  }

  function onEntitaChanged(value)
  {
    if (value.label == 'Cliente')
      $record.entityType = "Company";
    else if (value.label == 'Lead')
      $record.entityType = "Lead";
    else if (value.label == 'Contatto')
      $record.entityType = "Contact";
    else if (value.label == 'Affare')
      $record.entityType = "Deal";
    else
      $record.entityType = null;
  }

  onMount(() => initDetail(oid, entityId, type, $user.oid));
</script>

{#if $record}
  <div class="columns">
    <div class="column is-12">
      <FormLayout submitEnabled={cancreate && isNew || canedit && !isNew} {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
        {#if entityId == null}
        <div class="columns">
          {#if $record.oid == 0}
          <div class="column is-2">
            <FormField>
              <ClfDropdown
                name="Attività per"
                placeholder="Entità"
                schema="TASKENTITI"
                required={true} 
                on:select={(ev) => onEntitaChanged(ev.detail)}                
              />
            </FormField>
          </div> 
          {/if} 
          <div class="column is-10">
            <FormField>
              {#if $record.entityType == 'Company'}
              <CompanyDropdown
                name="Cliente"
                placeholder="Cliente"
                required={true}
                disabled={$record.oid != 0}
                bind:value={$record.entityId} 
              />
              {/if}
              {#if $record.entityType == 'Lead'}
              <LeadDropdown
                name="Lead"
                placeholder="Lead"
                required={true}
                disabled={$record.oid != 0}
                bind:value={$record.entityId} 
              />
              {/if}
              {#if $record.entityType == 'Contact'}
              <ContactDropdown
                name="Contatto"
                placeholder="Contatto"
                required={true}
                disabled={$record.oid != 0}
                bind:value={$record.entityId} 
              />
              {/if}
            </FormField>
          </div>  
        </div>
        {/if}

        <div class="columns">
          <div class="column is-12">
            <FormField>
              <Input
                name="Attività"
                placeholder="Attività"
                maxlength={499}
                required={true}
                bind:value={$record.activity.subject} 
              />
            </FormField>
          </div>  
        </div>

        <div class="columns">
          <div class="column is-3">
            <FormField>
              <ClfDropdown
              name="Stato"
              placeholder="Stato"
              schema="TASKSXXXXX"
              required={false} 
              bind:value={$record.activity.clfState} 
              on:select={(ev) => onStatoChange(ev.detail)}
            />     
            </FormField>
          </div>   

          <div class="column is-2">
            <FormField>
              <DateInput
                name="Data completamento"
                placeholder="Data completamento"
                required={false}
                maxlength={50}
                bind:value={$record.activity.doneDate} 
              />
            </FormField>
          </div>

          <div class="column is-2">
            <FormField>
              <DateInput
                name="Data scadenza"
                placeholder="Data scadenza"
                required={false}
                maxlength={50}
                bind:value={$record.activity.expireDate} 
              />
            </FormField>
          </div>

          <div class="column is-2">
            <FormField>
              <DateInput
                name="Data creazione"
                placeholder="Data creazione"
                required={false}
                maxlength={50}
                disabled={true}
                bind:value={$record.activity.createdOn} 
              />
            </FormField>
          </div>

          <div class="column is-3">
            <FormField>
              <DateInput
                name="Data ult. aggiornamento"
                placeholder="Data ult. aggiornamento"
                required={false}
                maxlength={50}
                disabled={true}
                calendarType="datetime"
                bind:value={$record.activity.updatedOn} 
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-3">
            <FormField>
              <PortalUserDropdown
                name="Assegnato a"
                placeholder="Assegnato a"
                required={false}
                bind:value={$record.activity.assignedTo} 
              />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <PortalUserDropdown
                name="Creato da"
                placeholder="Creato da"
                required={false}
                disabled={true}
                bind:value={$record.activity.createdBy} 
              />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <PortalUserDropdown
                name="Ult. aggiornamento"
                placeholder="Ult. aggiornamento"
                required={false}
                disabled={true}
                bind:value={$record.activity.updatedBy} 
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Textarea
                name="Nota"
                placeholder="Nota"
                required={false}
                rows={3}
                bind:value={$record.activity.commentText} 
              />
            </FormField>
          </div>

          <div class="column is-6">
            <FormField>
              <Textarea
                name="Nota completamento"
                placeholder="Nota completamento"
                required={false}
                rows={3}
                bind:value={$record.activity.noteOnCompletition} 
              />
            </FormField>
          </div>
        </div>
 
      </FormLayout>
    </div> 
  </div>
{/if}
